import { Directive, HostListener, Input, ElementRef } from '@angular/core';

@Directive({ selector: '[stopEvent]' })
export class StopEventDirective {
    @Input() stopEvent:string;

    constructor(el:ElementRef) {
        (<HTMLElement> el.nativeElement).addEventListener(this.stopEvent, function (e) {
            e.stopPropagation();
        });
    }
}


// WEBPACK FOOTER //
// ./web/static/services/directives/StopEvent.ts